
// Modules
import * as THREE from 'three'
import params from '../../utils/params'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

// Utils
import utils from '../../utils/utils'
import MyEmitter from '../MyEmitter'

export default class Scene3d{

    /**
     * 
     * @param {HTMLElement} container 
     * @param {Object} parameters 
     * @param {Boolean} parameters.rendererAlpha
     * @param {Number} parameters.cameraFov
     * @param {Boolean} parameters.premultipliedAlpha
     */
    constructor(container, parameters = {}, data = {}){

        console.log("CREATING A Scene3d", parameters, data)

        // set parameters
        parameters.rendererAlpha = utils.isUndefined(parameters.rendererAlpha) ? false : parameters.rendererAlpha
        parameters.cameraFov = utils.isUndefined(parameters.cameraFov) ? 75 : parameters.cameraFov
        parameters.premultipliedAlpha = utils.isUndefined(parameters.premultipliedAlpha) ? true : parameters.premultipliedAlpha

        this.parameters = parameters

        this.data = data

        this.container = container
        this.raf = null

        // bind
        this.onWindowResize = this.onWindowResize.bind(this)


        MyEmitter.once(params.Events.globalResize, () => this.onWindowResize())
    }

    // Publics
    onRender(){}

    // Core

    animate(){
        this.raf = requestAnimationFrame(() => this.animate())
        this.onRender()
        this.renderer.render(this.scene, this.camera)
    }

    start(){
        this.attachEvents()
        this.animate()
    }

    stop(){
        this.removeEvents()
        cancelAnimationFrame(this.raf)
        console.log("Scene3d has stopped", this)
    }

    destroy(){

        if(!this.isDestroyed){
            this.isDestroyed = true
            this.stop()
            this.disposeAll()
            console.log("Scene3d has destroyed", this)
        } else {
            console.log("prevent duplicate destroy")
        }

    }

    disposeAll(){

        // Dispose all

        this.scene.traverse(child => {

            if(child.type === "Mesh"){
                child.material.dispose()
                child.geometry.dispose()
            }

        })

        this.renderer.dispose()

        // Remove all children
        for (let i = this.scene.children.length - 1; i >= 0 ; i--) {
            let child = this.scene.children[ i ]
            this.scene.remove(child)
        }

        
    }

    /** Events */

    attachEvents(){
        window.addEventListener("resize", this.onWindowResize)
    }

    removeEvents(){
        window.removeEventListener("resize", this.onWindowResize)
    }

    onWindowResize(){
        this.camera.aspect = this.container.offsetWidth / this.container.offsetHeight
        this.camera.updateProjectionMatrix()
        this.renderer.setSize( this.container.offsetWidth, this.container.offsetHeight )
    }

    /** Init */

    init(){
        this.initRenderer()
        this.initCamera()
        this.initScene()
    }

    initScene(){
        this.scene = new THREE.Scene()
    }

    initCamera(){
        this.camera = new THREE.PerspectiveCamera( this.parameters.cameraFov, this.container.offsetWidth / this.container.offsetHeight, 0.1, 100 )
        this.camera.position.z = -5

        // @DEV
        // this.controls = new OrbitControls(this.camera, this.renderer.domElement)
    }

    initRenderer(){
        this.renderer = new THREE.WebGLRenderer({
            alpha: this.parameters.rendererAlpha,
            premultipliedAlpha: this.parameters.premultipliedAlpha
        })
        this.renderer.setSize( this.container.offsetWidth, this.container.offsetHeight )
        if(!this.parameters.clearColor === "none"){
            this.renderer.setClearColor(this.parameters.clearColor || new THREE.Color(0, 0, 0),0)
        }
        this.renderer.setPixelRatio( window.devicePixelRatio )
        this.renderer.domElement.classList.add("canvas")
        this.container.appendChild(this.renderer.domElement)
    }

    // static

    getCameraTarget(){

        let cameraTarget = new THREE.Mesh(
            new THREE.BoxBufferGeometry(1, 1, 1),
            new THREE.MeshBasicMaterial({
                color: "orange",
                side: THREE.DoubleSide
            })
        )

        cameraTarget.visible = false
        return cameraTarget
    }
    
}